











import Vue from "vue";
import store from "../store";

import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const chartCustomization = {
  id: "chartCustomization",
  beforeDraw(chart: any, args: any, options: any) {
    const {
      ctx,
      chartArea: { left, top, width, height }
    } = chart;
    const xAxis = chart.scales["x"];
    const yAxis = chart.scales["y"];

    // Draw chart border
    ctx.save();
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.setLineDash(options.borderDash || []);
    ctx.lineDashOffset = options.borderDashOffset;
    ctx.strokeRect(left, top, width, height);
    ctx.restore();

    // Step 1

    // Colwell Chart
    if (
      chart &&
      store.state.st === 1 &&
      chart.canvas.id === "criticalValueChart" &&
      store.state.step1.type === "Colwell"
    ) {
      let target = chart._metasets.filter((ms: any) =>
        ms.label.includes("Target")
      );
      let current = chart._metasets.filter((ms: any) =>
        ms.label.includes("Current")
      );
      if (target.length > 0 && current.length > 0) {
        ctx.save();
        ctx.fillStyle = "red";
        ctx.fillText(
          "Critical P",
          xAxis.right - 110,
          parseInt(target[0].data[0].y) - 10
        );
        ctx.fillStyle = "blue";
        ctx.fillText(
          "Current",
          xAxis.right - 45,
          parseInt(current[0].data[0].y) - 10
        );
        ctx.restore();
      }
    }
    // Olsen Chart
    if (
      chart &&
      store.state.st === 1 &&
      chart.canvas.id === "criticalValueChart" &&
      store.state.step1.type === "Olsen"
    ) {
      let target = chart._metasets.filter((ms: any) =>
        ms.label.includes("Target")
      );
      let current = chart._metasets.filter((ms: any) =>
        ms.label.includes("Current")
      );
      if (target.length > 0 && current.length > 0) {
        ctx.save();
        ctx.fillStyle = "red";
        ctx.fillText(
          "Critical P",
          parseInt(target[0].data[0].x) + 8,
          yAxis.maxWidth - 100
        );
        ctx.fillStyle = "blue";
        ctx.fillText(
          "Current",
          parseInt(current[0].data[0].x) + 8,
          yAxis.maxWidth - 75
        );
        ctx.restore();
      }
    }

    // Step 2

    // Stocking Rate Chart
    if (
      chart &&
      store.state.st === 2 &&
      chart.canvas.id === "stockingRateChart"
    ) {
      let avg = chart._metasets.filter((ms: any) =>
        ms.label.includes("Avg growing season")
      );
      let small = chart._metasets.filter((ms: any) =>
        ms.label.includes("Small paddocks")
      );
      let large = chart._metasets.filter((ms: any) =>
        ms.label.includes("Large paddocks")
      );
      if (avg.length > 0 && small.length > 0 && large.length > 0) {
        ctx.save();
        ctx.fillStyle = "red";
        ctx.fillText(
          "Avg growing season",
          parseInt(avg[0].data[0].x) + 8,
          yAxis.maxWidth - 75
        );
        ctx.fillStyle = "red";
        ctx.fillText(
          "Small paddocks",
          parseInt(small[0].data[0].x) + 14,
          parseInt(small[0].data[0].y) - 10
        );
        ctx.fillStyle = "red";
        ctx.fillText(
          "Large paddocks",
          parseInt(large[0].data[0].x) + 14,
          parseInt(large[0].data[0].y) - 10
        );
        ctx.restore();
      }
    }
    // Targeting Chart
    if (chart && store.state.st === 2 && chart.canvas.id.startsWith("cc")) {
      let currentStockingRate = chart._metasets.filter((ms: any) =>
        ms.label.includes("Current stocking rate")
      );
      let targetValue = chart._metasets.filter((ms: any) =>
        ms.label.includes("Target value")
      );
      let predictedValue = chart._metasets.filter((ms: any) =>
        ms.label.includes("Predicted")
      );
      let max = chart._metasets.filter((ms: any) =>
        ms.label.includes("95% of max")
      );

      // This section is for setting the labels on the charts
      if (
        currentStockingRate.length > 0 &&
        targetValue.length > 0 &&
        predictedValue.length > 0
      ) {
        ctx.save();
        ctx.fillStyle = "red";
        ctx.fillText(
          "Your",
          parseInt(currentStockingRate[0].data[0].x) + 10,
          parseInt(currentStockingRate[0].data[0].y)
        );
        ctx.fillText(
          "current",
          parseInt(currentStockingRate[0].data[0].x) + 10,
          parseInt(currentStockingRate[0].data[0].y) + 15
        );
        ctx.fillText(
          "position",
          parseInt(currentStockingRate[0].data[0].x) + 10,
          parseInt(currentStockingRate[0].data[0].y) + 30
        );
        if (
          chart.canvas.id === "ccTargetingChart" &&
          (
            store.state.step2.type === "stockingRate"
            ? parseFloat(store.state.step2.fertilityTarget)
            : parseFloat(store.state.step2.stockingRateTarget)
          ) > 0
        ) {
          ctx.fillText(
            "Target",
            parseInt(targetValue[0].data[0].x) + 10,
            parseInt(targetValue[0].data[0].y) - 10
          );
          // ctx.fillText(
          //   "Target",
          //   parseInt(store.state.step2.targetChartLabelX) + 10,
          //   parseInt(store.state.step2.targetChartLabelY) - 10
          // );
          ctx.fillText(
            "Predicted",
            parseInt(predictedValue[0].data[0].x) + 10,
            parseInt(predictedValue[0].data[0].y) - 10
          );
        }
        ctx.fillStyle = "green";
        ctx.fillText(
          "95% of max",
          parseInt(max[0].data[0].x) + 80,
          parseInt(max[0].data[0].y) - 10
        );
        ctx.restore();
      }
    }

    // Step 5

    // Stocking Rate & Soil Fertility Program
    if (
      chart &&
      store.state.st === 5 &&
      chart.canvas.id === "SRvsSF"
    ) {
      ctx.save();
      ctx.font = '14px Arial';
      ctx.rotate(-0.5 * Math.PI);
      ctx.fillText("Soil fertility level (mg P/kg)", -(chart.chartArea.height - chart.chartArea.top) + 5, chart.width - 10);
      ctx.restore();
    }
  }
};

export default Vue.component("chart", {
  data() {
    return {
      chart: null
    };
  },
  mounted(this: any) {
    // console.log(this.id, this.datasets)
    // window.addEventListener('resize', this.onResize)
    setTimeout(() => {
      this.generateChart();
    }, this.loadTime);
  },
  beforeDestroy(this: any) {
    // window.removeEventListener('resize', this.onResize)
  },
  props: {
    id: String,
    type: String,
    data: Object,
    options: Object,
    loadTime: Number // milliseconds
  },
  // If any of the following store values are changed
  // then the chart will update
  computed: {
    step1() {
      return (
        store.state.step1.value + store.state.step1.pbi + store.state.step1.type
      );
    },
    step2() {
      return (
        store.state.step2.avgGrowingSeason +
        store.state.step2.potCarryingCapacity +
        store.state.step2.typical.pTest +
        store.state.step2.typical.carryingCapacity +
        store.state.step2.potential.carryingCapacity +
        store.state.step2.stockingRateCurrent +
        store.state.step2.target +
        store.state.step2.fertilityTarget +
        store.state.step2.stockingRateTarget +
        store.state.step2.type
      );
    }
  },
  // Generate the chart using the passed properties
  // id, datasets and options - update datasets & options
  methods: {
    generateChart: function(this: any) {
      //const canvas = document.getElementById(this.id) as HTMLCanvasElement;
      //const ctx = canvas.getContext('2d');
      var ctx = document.getElementById(this.id);
      this.chart = new Chart(
        ctx,
        {
          type: this.type,
          data: this.data,
          options: this.options,
          plugins: [chartCustomization]
        } /* as any*/
      );
      // this.chart.resize();
    },
    updateChart: function(this: any) {
      this.chart.data = this.data;
      this.chart.options = this.options;
    }
    /*onResize: function (this:any) {
      this.chart.resize()
      this.chart.update()
    }*/
  },
  // Watch for changes in the above computed models,
  // call update functions on change
  watch: {
    step1: function(this: any) {
      this.updateChart();
      this.chart.update();
    },
    step2: function(this: any) {
      this.updateChart();
      this.chart.update();
    }
  }
});
